module.exports = __webpack_public_path__ + "static/media/login.dc8bf4cd.jpeg";